import { fromClass } from "fw-model";

export enum OrganizationTemplateType {
    AtsOrganization = 0,
    Manual = 1
}

class AtsOrganizationTemplateMetaData {
    Type: OrganizationTemplateType;
    ActiveVersion: number;
    AtsOrganizationName: string;
    OrganizationId: string;
    SeasonId: string;
    LastPulledUtc: string;
    ValidationResult: any;
}

export class AtsOrganizationTemplate {
    Id: string;
    Name: string;
    Paths: string[];
    SeasonConfiguration: any;
    @fromClass MetaData: AtsOrganizationTemplateMetaData;
}
